const ua = navigator.userAgent.toLocaleLowerCase()
// 判断是不是手机微信
export const isMobileWeChat = /micromessenger/.test(ua) && !/windowswechat|macwechat/.test(ua)



// WEBPACK FOOTER //
// ./src/core/env.js